import React, { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import Icon from 'storybookComponents/Icon';
import 'bootstrap/dist/css/bootstrap.css';
import "./style.css";
import Form from "./form"


const useStyles = makeStyles((theme) => ({
  mainContainer: {
    position: "absolute",
    top: 20,
    right: 20
  },
  formField: {
    color: "rgba(51, 51, 51, 0.5)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Open Sans",
  },
  iconStyle: {
    cursor: 'pointer',
    "&:hover": {
      color: "#26bbbed"
    }
  },
  popoverBody: {
    maxHeight: 400,
    overflowY: "auto",
    paddingLeft: 20,
    paddingRight: 20
  }
}));



const SimplePopover = ({ ...props }) => {
  const classes = useStyles();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  return (
    <div id="guest-rsvp-popover-container" className={classes.mainContainer}>
      <div id="PopoverHyForm" className={classes.iconStyle} onClick={toggle}>
        <Icon size="sm" type="icon-pencil" />
      </div>
      <Popover placement="bottom-end" isOpen={popoverOpen} target="PopoverHyForm" toggle={toggle} className="guest-rsvp-popover">
        <PopoverBody>
          <div className={classes.popoverBody}>
            <div className={classes.formField}>Form Fields</div>
            <Form {...props} toggle={toggle} />
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
}

export default SimplePopover;